import { MotionProps } from 'framer-motion';
import React, { ReactNode } from 'react';

import { pageTransitionDuration } from '../../../constants';
import { StyledMotionDiv } from './FadeInAnimation.styles';

interface FadeInAnimationProps {
  children: ReactNode;
  duration?: number;
  enableAnimation?: boolean;
  exit?: MotionProps['exit'];
  // When provided, controls whether content is visible (true=fade in, false=stay hidden).
  // Useful for delaying the fade-in until data is ready.
  visible?: boolean;
}

const FadeInAnimation = ({
  children,
  duration = pageTransitionDuration,
  enableAnimation,
  visible,
  ...rest
}: FadeInAnimationProps): any => {
  const variants = {
    initial: { opacity: enableAnimation === false ? 1 : 0 },
    enter: { opacity: 1 },
  };

  const animateTarget = visible !== undefined ? (visible ? 'enter' : 'initial') : 'enter';

  return (
    <StyledMotionDiv
      initial="initial"
      animate={animateTarget}
      exit="initial"
      variants={variants}
      transition={{ duration }}
      {...rest}
    >
      {children}
    </StyledMotionDiv>
  );
};

export default FadeInAnimation;
